import { render, staticRenderFns } from "./DailyFeesSection.vue?vue&type=template&id=4a24beba&"
import script from "./DailyFeesSection.vue?vue&type=script&lang=js&"
export * from "./DailyFeesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports